<template>
  <div
    v-if="mShowDialog"
    class="tip-match-center-popup-wrap"
    @click.stop="cancel()"
  >
    <div
      class="tip-match-popup-content"
    >
      <p class="tip-match-popup-title">
        {{ content }}
      </p>
      <p class="tip-match-popup-tip-desc">
        {{ subcontent }}
      </p>
      <div
        v-if="qrCodeUrl || src"
        class="tip-match-popup-code-wrap"
      >
        <VueQrcode
          v-if="qrCodeUrl"
          class="tip-match-popup-code"
          :value="qrCodeUrl"
        />
        <image
          v-else-if="src"
          class="tip-match-popup-code"
          mode="widthFix"
          :show-menu-by-longpress="true"
          :src="src"
          @click.stop="onClickImg(src)"
        />
      </div>
      <div
        v-if="!cancelText"
        class="tip-match-popup-btn-wrap"
      >
        <div
          class="tip-match-popup-form-btn"
          :class="lightbtn ? 'tip-match-popup-lightbtn':''"
          @click.stop="confirm()"
        >
          {{ confirmText }}
        </div>
      </div>
      <div
        v-else
        class="tip-match-popup-btn-wrap"
      >
        <div
          class="tip-match-popup-btn-flex"
          @click.stop="cancel()"
        >
          {{ cancelText }}
        </div>
        <div
          class="tip-match-popup-btn-flex"
          :class="lightbtn ? 'tip-match-popup-lightbtn':''"
          @click.stop="confirm()"
        >
          {{ confirmText }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueQrcode from 'src/component/ui/widget/qrcode';
export default {
  options: {
    virtualHost: true,
  },
  components: {
    VueQrcode,
  },
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    content: {
      type: String,
      default: '',
      required: false,
    },
    subcontent: {
      type: String,
      default: '',
      required: false,
    },
    src: {  // 图片链接
      type: String,
      default: '',
      required: false,
    },
    qrCodeUrl: {  // 二维码链接
      type: String,
      default: '',
      required: false,
    },
    canTouchRemove: { // 是否可以触摸蒙层隐藏
      type: Boolean,
      default: true,
      required: false,
    },
    confirmText: {
      type: String,
      default: '确定',
      required: false,
    },
    cancelText: {
      type: String,
      default: '取消',
      required: false,
    },
    // 按钮是否高亮
    lightbtn: { // 是否可以触摸蒙层隐藏
      type: Boolean,
      default: false,
      required: false,
    },
    onConfirm: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      mShowDialog: false,
    };
  },
  mounted() {

  },
  methods: {
    setData(data) {
      Object.keys(data).forEach((key) => {
        try {
          this[key] = data[key];
        } catch (err) {
        }
      });
    },
    show() {
      this.mShowDialog = true;
    },
    confirm() {
      this.$emit('onConfirm');
      if (this.onConfirm && typeof this.onConfirm === 'function') {
        this.onConfirm();
      }
      this.remove();
    },
    cancel() {
      this.remove();
    },
    remove() {
      this.mShowDialog = false;
    },
    onClickImg(src) {
      // QQ小程序需要先预览，后保存
      if (this.isMPQQ) {
        // qq.previewImage({
        //   urls: [src], // 需要预览的图片http链接列表
        //   success: (res) => {
        //     console.log('res: ', res);
        //   },
        //   fail: (err) => {
        //     console.error('err: ', err);
        //   },
        // });
        uni.getImageInfo({
          src,
          success(res) {
            uni.previewImage({
              urls: [res.path], // 要预览的图片URL数组
            });
          },
        });
      }
    },
  },
};

</script>
<style lang="scss" scoped src="./css/index.scss"></style>
